import { FunnelDev } from "@/backend/commands/funnel/types"
import {
  MAX_CV_SIZE_BYTES,
  buildCvBlobPathname,
  isAllowedCvExtension,
} from "@/features/funnel/cv-upload-constraints"
import { trackFunnelDevConversion } from "@/integrations/tracking/gtm"
import { Locale } from "@/lib/i18n"
import { upload } from "@vercel/blob/client"
import axios from "axios"

type FunnelDevClientInput = Omit<FunnelDev, "cvBlob" | "locale"> & {
  cvFile: File
  locale: Locale
}

export const invokeFunnelDev = async (input: FunnelDevClientInput) => {
  try {
    if (!isAllowedCvExtension(input.cvFile.name)) {
      return false
    }

    if (input.cvFile.size > MAX_CV_SIZE_BYTES) {
      return false
    }

    const blobPathname = buildCvBlobPathname(input.cvFile.name)
    const blob = await upload(blobPathname, input.cvFile, {
      access: "private",
      handleUploadUrl: "/api/blob/upload-cv",
      multipart: true,
    })

    const blobUrl = blob.url?.trim()
    const blobDownloadUrl = blob.downloadUrl?.trim() || blobUrl

    if (!blobUrl || !blobDownloadUrl) {
      return false
    }

    await axios.post("/api/pushFunnelDev", {
      locale: input.locale,
      linkedinUrl: input.linkedinUrl,
      isFreelancer: input.isFreelancer,
      devPower: input.devPower,
      firstName: input.firstName,
      lastName: input.lastName,
      email: input.email,
      phoneNumber: input.phoneNumber,
      jobTypes: input.jobTypes,
      jobLengths: input.jobLengths,
      cvBlob: {
        pathname: blob.pathname,
        url: blobUrl,
        downloadUrl: blobDownloadUrl,
        contentType: blob.contentType,
        size: input.cvFile.size,
        originalFilename: input.cvFile.name,
      },
    })
    trackFunnelDevConversion({
      locale: input.locale,
      isFreelancer: input.isFreelancer,
      devPower: input.devPower,
      jobTypes: input.jobTypes.map((item) => item.value),
      jobLengths: input.jobLengths.map((item) => item.value),
    })
    return true
  } catch {
    return false
  }
}
